module.exports = __webpack_public_path__ + "static/media/6.61bce54c.JPG";